<div>
  <div bsModal #editFlagModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="EditFlag">
    <div class="modal-dialog modal-sm" style="width: 300px" role="document" [ngStyle]="modalStyle">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="EditFlag" class="modal-title">Edit Flag</h4>
          <button *ngIf="flag?.pictureId" (click)="clickUnlink()" class="btn btn-sm btn-secondary">Unlink</button>
        </div>
        <div class="modal-body">
          <p *ngIf="lockTypeAndGroup" class="text-muted" style="font-size: 12px; margin-bottom: 12px">
            Type, subtype, and group are managed via Issue Details. You can still edit the note and score.
          </p>
          <form [formGroup]="editFlagForm">
            <div class="form-group">
              <label for="name">What type of flag is it?</label>
              <select formControlName="flagType" class="form-control">
                <option
                  *ngFor="let t of flagTypes"
                  [ngValue]="t"
                  [attr.disabled]="t.name == 'Legacy' ? true : null"
                  [hidden]="hideLegacy && t.name == 'Legacy'">
                  {{ t.name }}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="editFlagForm.get('flagType').value?.name == 'Violation'">
              <label for="name">and subtype?</label>
              <select formControlName="flagSubtype" class="form-control">
                <option *ngFor="let st of flagSubtypes" [ngValue]="st">{{ st?.name }}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="scoresEnabled">
              <label for="name">Score</label>
              <select formControlName="score" class="form-control">
                <option [ngValue]="0">0</option>
                <option [ngValue]="1">1</option>
                <option [ngValue]="3">3</option>
                <option [ngValue]="5">5</option>
                <option [ngValue]="10">10</option>
                <option [ngValue]="100">100</option>
              </select>
            </div>

            <div class="form-group">
              <label>Group</label>
              <ng-select
                #ngSelectComponent
                formControlName="group"
                [items]="groups"
                [addTag]="addTagFn"
                [hideSelected]="true"
                addTagText="Add new group"
                placeholder="Select or add a group"
                bindValue="name"
                bindLabel="name"
                [ngClass]="getValidationClass('group')"
                (change)="onGroupSelected($event)"
                (search)="onSearch($event)"
                (clear)="onClearSearch()">
                <ng-template ng-option-tmp let-item="item">
                  <span [ngClass]="item.class">{{ item.name }}</span>
                </ng-template>
              </ng-select>
              <p *ngIf="editFlagForm.get('group').invalid && editFlagForm.get('group').touched" class="text-danger">
                This group already exists with a different type/subtype
              </p>
            </div>

            <div class="form-group">
              <label for="name">Note</label>
              <textarea formControlName="text" class="form-control"></textarea>
            </div>
          </form>
          <br />

          <div style="text-align: right">
            <button type="button" [disabled]="saving" class="btn btn-sm aru btn-secondary" (click)="cancel()">
              Cancel</button
            >&nbsp;

            <ng-container>
              <button
                [disabled]="saving"
                type="button"
                class="btn btn-sm aru btn-danger"
                *ngIf="!hideDelete"
                (click)="remove()">
                Remove</button
              >&nbsp;
              <button
                type="button"
                class="btn btn-sm aru btn-primary"
                [disabled]="editFlagForm.invalid || saving"
                (click)="onSave()">
                Save Flag
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
